import { Pagination, Tooltip } from 'antd';
import Loading from 'components/Basic/Loading';
import * as dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { FormattedMessage, useIntl } from 'react-intl';
import 'react-phone-input-2/lib/style.css';
import moment from 'moment-timezone';
import React, { useState, useEffect } from 'react';
import { useLazyGetCustomerPhoneHistotyByIdQuery } from 'core/customer/CustomerService';

dayjs.extend(utc);
dayjs.extend(timezone);

const UserPhoneHistory = ({ match }) => {
  const intl = useIntl();
  const { params } = match;
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [userData, setUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [getUserPhoneHistory] = useLazyGetCustomerPhoneHistotyByIdQuery();

  useEffect(() => {
    onChangePage(0, 10);
  }, []);

  const handleChangePage = (page, size) => {
    setCurrent(page);
    setPageSize(size);
    onChangePage((page - 1) * size, size);
  };

  const onChangePage = async (page, size) => {
    setIsLoading(true);
    try {
      /*const queryString = buildQueryString({
        phone: state.phoneForCheck,
        page: page,
        size: size,
        count: true,
      });*/
      const userData = await getUserPhoneHistory(params.id).unwrap();
      setUserData(userData);
      setTotal(userData.length);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
    }
  };

  const handleShowSizeChange = (c, s) => {
    handleChangePage(1, s);
  };

  return (
    <>
      <div className="user_manage_layout">
        <div className="user_manage_phone_wrapper">
          <h3>
            <FormattedMessage id="Phone number" />
          </h3>
          <div className="user_edit_table_layout">
            <div className="user_manage_table_header">
              <div className="userPhone">
                <FormattedMessage id="Phone number" />
              </div>
              <div className="numberStatus">
                <FormattedMessage id="Phone number status" />
              </div>
              <div className="changedBy">
                <FormattedMessage id="Status changed by" />
              </div>
              <div className="reason">
                <FormattedMessage id="Reason of status changed" />
              </div>
              <div className="receivedAt">
                <FormattedMessage id="Date and time of status received" />
              </div>
            </div>
            <div className="table_content">
              {userData &&
                userData.map((item, index) => (
                  <div className="user_manage_table_item" key={index}>
                    <div className="userPhone">
                      <p>{item.phone}</p>
                    </div>
                    <div className="numberStatus">
                      <div className={`status_wrapper status_${item.newStatus?.match(/^\w+/)[0]}`}>
                        <p>
                          <FormattedMessage id={item.newStatus} />
                        </p>
                      </div>
                    </div>
                    <div className="changedBy">
                      <p>
                        {item.adminId ? (
                          <>
                            <FormattedMessage id={'Admin ID'} /> {` ${item.adminId}`}
                          </>
                        ) : (
                          <>
                            <FormattedMessage id={'Customer ID'} /> {` ${item.customerId}`}
                          </>
                        )}
                      </p>
                    </div>
                    <div className="reason">
                      <p>
                        <FormattedMessage id={item.description} />
                      </p>
                    </div>
                    <div className="receivedAt">
                      <p>
                        {item.createdAt
                          ? `${moment(item.createdAt).tz('America/Guatemala').format('LL')} 
                                    @ ${moment(item.createdAt).tz('America/Guatemala').format('HH:mm')}`
                          : ''}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
            {/*<div className="pagination_wrapper">
              <Pagination
                showSizeChanger
                defaultCurrent={1}
                defaultPageSize={10}
                current={current}
                pageSize={pageSize}
                pageSizeOptions={['5', '10', '20', '30']}
                total={total}
                onChange={handleChangePage}
                onShowSizeChange={handleShowSizeChange}
              />
              <div className="total">Resultados: {total}</div>
            </div>*/}
          </div>
        </div>
      </div>
      <Loading visible={isLoading} />
    </>
  );
};

export default UserPhoneHistory;
